(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairStudentsRegistrationsDataController', PhysicalFairStudentsRegistrationsDataController);

    PhysicalFairStudentsRegistrationsDataController.$inject = ['ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];


    function PhysicalFairStudentsRegistrationsDataController(ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;


        vm.flag                     = false;
        vm.expo                     = [];
        vm.expoSelected             = [];
        vm.cities                   = [];

        vm.i                        =-1;

        vm.titleCity                ='';
        vm.titleCountry             ='';

        vm.selectExpo               = selectExpo;
        vm.selectCitiesByExpo       = selectCitiesByExpo;
        vm.getByFilter              = getByFilter;
        vm.quality                  = quality;
        vm.citySelected             = [];
        vm.statusSelected           = [];
        vm.status                   = [{id: 0, name : 'All'},{id: 1, name : 'Attended'}];

        vm.percentage               = percentage;
        vm.percentageQuality        = percentageQuality;
        vm.formatPercent            = formatPercent;
        vm.dateFormat               = dateFormat;
        vm.formatAreaXLabel         = formatAreaXLabel;
        vm.formatAreaYLabel         = formatAreaYLabel;
        vm.registrationsGraph       = [];
        vm.changeRegisteredGraph    = changeRegisteredGraph;
        vm.registrationDate         = {startDate: null, endDate: null};

        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        vm.showPending              = true;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.citySelected          = [];
                vm.cities = response.data;
                vm.cities.unshift({id:-1, city_name : 'All'});
            }).catch(function(err) {

            });
        }


        function getByFilter() {
            vm.flag = false;
            vm.query = {};

            vm.query['expo_id']         = vm.expoSelected.id;
            vm.query['city_id']         = vm.citySelected.id;
            vm.query['school_visit']    = vm.citySelected.is_school_visit;

            if(typeof vm.statusSelected !== 'undefined') {
                vm.query['attended'] = vm.statusSelected.id;
            }

            if (vm.registrationDate.startDate && vm.registrationDate.endDate) {
                vm.query['registration_date_start']  = moment(vm.registrationDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['registration_date_end']    = moment(vm.registrationDate.endDate).format('YYYY-MM-DD 23:59:59');
            }

            PhysicalFairService.getByFilterStudentsRegistrations(vm.query).then(function(response){
                if(typeof vm.statusSelected !== 'undefined' && vm.statusSelected.id === 1) {
                    vm.showPending = false;
                }
                else{
                    vm.showPending = true;
                }
                if(response.data.locations){
                    vm.locationIndex = Object.keys(response.data.locations)[0];
                    vm.registrationsGraph = response.data.locations[vm.locationIndex].registrations.slice().reverse();
                    vm.daysforexpo = response.data.locations[vm.locationIndex].days_for_expo;
                }

                vm.students = response.data;
                vm.flag = true;
                vm.titleCity = vm.citySelected.city_name;
                vm.titleCountry = vm.expoSelected.name;
            }).catch(function(err){

            });

            vm.flagForViewGraph = true;
        }

        function quality(family){
            if(vm.students.total){
                return (parseInt(family)*100 / vm.students.total).toFixed(2);
            }
            return 0;
        }

        function percentage(qtd,total)
        {
            if(qtd > 0){
                return (parseInt(qtd)*100 / total).toFixed(2);
            }
            return 0;
        }

        function percentageQuality(qtd,total)
        {
            if(qtd > 0 && total > 0){
                return ((parseInt(qtd) / parseInt(total))*100).toFixed(2);
            }
            return 0;
        }

        function formatPercent(input)
        {
            return input + '%';
        }

        function dateFormat(date) {
            return date.getDate()+'/'+(date.getMonth()+1)+'/'+date.getFullYear();
        }

        function formatAreaXLabel(input) {
            //return (input.src.x + ' days before').toString();
            return (input.src.x).toString();
        }

        function formatAreaYLabel(input) {
            return parseInt(input);
        }

        function changeRegisteredGraph(registrations){
            vm.registrationsGraph = registrations.slice().reverse();
        }
        activate();

    }

})();